<div class="container container_type_main">
  <div class="page-error">
    <div class="page-error__content">
      <div class="page-error__title">{{ '404-page.title' | translate }}</div>
      <div class="page-error__subtitle">{{ '404-page.text' | translate }}</div>
      <div class="page-error__button">
        <a routerLink="/" class="button">{{ '404-page.to-main' | translate }}</a>
      </div>
    </div>
    <div class="page-error__img">
      <img src="/img/cats/not-found.png" [alt]="'404-page.title' | translate">
    </div>
  </div>
</div>
